module.exports = __webpack_public_path__ + "static/img/pro1.jpg.b74757ea.png";